import { render, staticRenderFns } from "./GlobalMessage.vue?vue&type=template&id=1edd5ba8&scoped=true"
import script from "./GlobalMessage.vue?vue&type=script&lang=ts"
export * from "./GlobalMessage.vue?vue&type=script&lang=ts"
import style0 from "./GlobalMessage.vue?vue&type=style&index=0&id=1edd5ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd5ba8",
  null
  
)

export default component.exports